import {ModerationUser, ModerationUserTag, UserActor} from "interfaces";
import {getPhotoInfosFromTag, ReviewTagInfoTypes, UserReviewTags} from "enums";

export enum PhotoLocation {
    Profile = 'Profile',
    Features = 'Features',
    Archive = 'Archive'
}

export const PHOTO_LOCATION_DESCRIPTIONS: Record<PhotoLocation, string> = {
    [PhotoLocation.Archive]: '🗃️ Архив',
    [PhotoLocation.Features]: '🦵 Части тел',
    [PhotoLocation.Profile]: '👤 Профиль',
} as const;

export interface PhotoInfo {
    key: string;
    photo: any;
    location: PhotoLocation | null;
}

export function getDuplicateUsers(tag: ModerationUserTag, user: ModerationUser): UserActor[] {
    if (tag.tag === UserReviewTags.DuplicateFacePhotos) {
        if (tag.infoValue) {
            return (user.duplicateFaces?.find(f => f.photoKey === tag.infoValue)?.users.filter(u => u.user.key !== user.id).map(v => v.user) ?? []);
        }

        const userKeys = tag.relatedInfos?.filter(i => i.infoType === ReviewTagInfoTypes.User).map(v => v.infoValue);


        if (!userKeys || userKeys.length < 1) {
            return []
        }

        return (
            Array.from(
                new Map(
                    user.duplicateFaces
                        ?.map(f => f.users.find(u => userKeys.includes(u.user.key)))
                        .filter(u => !!u && u.user.key !== user.id)
                        .map(u => [u?.user.key, u?.user]) // key by user.key
                ).values() as any
            ) ?? []
        );
    }

    if (tag.tag === UserReviewTags.DuplicateHashPhoto) {
        const key = tag.infoValue ? tag.infoValue : tag.info
        return (user.photosWithDuplicateHashes?.find(f => f.photoKey === key)?.usersWithDuplicate.filter(u => u.key !== user.id) ?? []);
    }

    return []

}

export function getPhotoInfos(tag: ModerationUserTag, user: ModerationUser): PhotoInfo[] | null {
    const photoInfos = getPhotoInfosFromTag(user, tag);

    if (!photoInfos || !photoInfos.length) {
        return null;
    }

    return photoInfos.map(v => findPhoto(user, v.key));
}

export function findPhoto(user: ModerationUser, photoKey: string) {
    const profilePhoto = user.photos?.find(p => p.key === photoKey);
    const featurePhoto = user.attractiveFeatures?.find(f => f.photo?.key === photoKey)?.photo;
    const archivePhoto = user.deletedPhotos?.find(f => f.key === photoKey);

    const location = profilePhoto ? PhotoLocation.Profile : featurePhoto ? PhotoLocation.Features : archivePhoto ? PhotoLocation.Archive : null;
    return {key: photoKey, photo: profilePhoto ?? featurePhoto ?? archivePhoto, location}
}
